var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M29.948 8a11.422 11.422 0 0 1-3.28.92 5.731 5.731 0 0 0 2.507-3.173 11.521 11.521 0 0 1-3.627 1.4C24.495 6 23.015 5.333 21.335 5.333c-3.134 0-5.694 2.56-5.694 5.72 0 .454.054.894.147 1.307A16.26 16.26 0 0 1 4.001 6.387a5.659 5.659 0 0 0-.773 2.866c0 1.987 1 3.747 2.547 4.747-.947 0-1.827-.267-2.6-.667v.04a5.724 5.724 0 0 0 4.586 5.614c-.839.23-1.72.261-2.573.093a5.707 5.707 0 0 0 5.333 3.973 11.362 11.362 0 0 1-7.106 2.454c-.454 0-.907-.027-1.36-.08A16.193 16.193 0 0 0 10.828 28c10.507 0 16.28-8.72 16.28-16.28 0-.253 0-.493-.013-.747 1.12-.8 2.08-1.813 2.853-2.973Z"}));
}

Twitter.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
